var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnRadioInconCheckInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#D4D9DB",
    fill: "#FFF",
    fillRule: "nonzero",
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E9ECED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m7 11.714 2.571 2.571 5.143-5.142"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnRadioInconCheckInactive);
export default __webpack_public_path__ + "static/media/btn-radio-incon-check-inactive.273b7f3f61ad6009f33656044094526a.svg";
export { ForwardRef as ReactComponent };